// extracted by mini-css-extract-plugin
export var cardLayout = "_2h-1";
export var paginationContainer = "_2h-0";